import Cookies from 'js-cookie';

import { formatToISOLocal } from '~helpers/date/formatToISOLocal';
import { CookieValues } from '~types/Cookie.types';

export type BatutRequest = {
  title: string;
  fields: {
    email: string;
    phone: string;
    comment?: string;
    company?: string;
    information?: boolean;
    name?: string;
  };
  bitrix?: {
    comment?: string;
    descriptionId?: number;
    sourceId?: number;
  };
};

export const prepareFosData = ({ fields, bitrix, title }: BatutRequest) => {
  return {
    fields: {
      TITLE: title,
      NAME: fields.name,
      EMAIL: [{ VALUE: fields.email, VALUE_TYPE: 'WORK' }],
      PHONE: [{ VALUE: fields.phone, VALUE_TYPE: 'WORK' }],
      COMPANY_TITLE: fields.company,
      COMMENTS: fields.comment,
      UF_CRM_1611751162: fields.email,
      SOURCE_ID: bitrix?.sourceId ?? 1,
      UF_CRM_1612183146977: '-',
      UF_CRM_1625487687965: bitrix?.comment,
      UF_CRM_1612291392497: bitrix?.descriptionId ?? 933,
      // ClientID Яндекс.Метрики
      UF_CRM_YA_CID: Cookies.get(CookieValues.YmUID),
      SOURCE_DESCRIPTION: document.URL,
      information: fields.information,
      ...(fields.information && {
        UF_CRM_INFORMATIONAGREEMENTTIME: formatToISOLocal(Date.now()),
      }),
    },
  };
};
